import { sampleProjects } from "./mockData.mjs";

const STORAGE_KEY = "zhangfa.projects.v1";

export function loadProjects() {
  if (typeof localStorage === "undefined") return structuredClone(sampleProjects);
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return structuredClone(sampleProjects);
  try {
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : structuredClone(sampleProjects);
  } catch {
    return structuredClone(sampleProjects);
  }
}

export function saveProjects(projects) {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
}

export function upsertProject(projects, project) {
  const index = projects.findIndex((item) => item.id === project.id);
  if (index === -1) return [project, ...projects];
  const next = [...projects];
  next[index] = project;
  return next;
}

export function createProjectFromArticle(article, inputType = "主题") {
  return {
    id: `p-${Date.now()}`,
    title: article.title,
    updatedAt: "刚刚",
    score: null,
    inputType,
    article
  };
}
